import type { ModerationCase } from "@/redux/moderation/types";
import type { CaseKind } from "@/features/community/moderation/types";
import { MODERATION_CONTENT_KINDS } from "@/domains/moderation/constants";
import { CASE_KINDS } from "@/features/community/moderation/constants";

const EDIT_THRESHOLD_MS = 60_000;

export const getCaseKind = (moderationCase: ModerationCase): CaseKind => {
  if (moderationCase.contentKind === MODERATION_CONTENT_KINDS.DISCUSSION) {
    return CASE_KINDS.POST;
  }
  return moderationCase.replyTo ? CASE_KINDS.REPLY : CASE_KINDS.COMMENT;
};

export const getCaseContent = (moderationCase: ModerationCase) =>
  moderationCase.contentKind === MODERATION_CONTENT_KINDS.COMMENT
    ? moderationCase.comment
    : moderationCase.discussion;

export const isEdited = (moderationCase: ModerationCase) => {
  const content = getCaseContent(moderationCase);
  if (!content) {
    return false;
  }
  return (
    new Date(content.updatedAt).getTime() -
      new Date(content.createdAt).getTime() >
    EDIT_THRESHOLD_MS
  );
};

export const getVerdictKey = (moderationCase: ModerationCase) => {
  const [category] = moderationCase.aiCategories;
  if (category) {
    return `moderation.categories.${category}`;
  }
  if (moderationCase.escalationReason) {
    return `moderation.escalation.${moderationCase.escalationReason}`;
  }
  return "moderation.escalation.unknown";
};

export const getCertificationWeek = (
  moderationCase: ModerationCase,
  weekByTopic: Map<number, number>,
) => {
  const topics = moderationCase.discussion?.topics ?? [];
  for (const topic of topics) {
    const week = weekByTopic.get(topic.id);
    if (week !== undefined) {
      return week;
    }
  }
  return null;
};
